import { Component, ElementRef, EventEmitter, Injector, Input, ViewChild } from '@angular/core';
import { ItemFinderComponent } from '../item-finder.component';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { OperatorEnum, OperatorUtil } from '../../../ui/OperatorUtil';
import { AuthService } from '../../../service/auth-service/auth-service.service';
import { LocalStorageUtil } from '../../../ui/LocalStorageUtil';
import { LIMIT_FOR_HISTORIES, OPERATOR_LABEL_DICCIONARY } from '../../../ui/Constants';
import { MeddraService } from '../../../service/meddra-service/meddra.service';
import { environment } from '../../../../../environments/environment';
import { MedicinalproductsService } from '../../../service/medicinalproducts-service/medicinalproducts.service';
import { WebtraderService } from '../../../service/webtrader-service/webtrader.service';
import { testingEnum } from '../../../common/enum/testingEnum';
import { OnDemandAutoUploadNode } from '../../../ui/Node/MedicinalProductsNode/OnDemandAutoUploadNode';

@Component({
  selector: 'app-item-finder-search-bar',
  templateUrl: './item-finder-search-bar.component.html',
  styleUrl: './item-finder-search-bar.component.scss'
})
export class ItemFinderSearchBarComponent extends ItemFinderComponent {

  override selectedNode: any;
  @ViewChild('operatorInput') operatorInput!: ElementRef;
  @ViewChild('filterBox') filterBox!: ElementRef;
  constructor(override injector: Injector) {
    super(injector);
  }

  refreshCriteria() {
    this.selectedNode.operatorSelected = this.operatorInput.nativeElement.value;
    this.selectedNode.criteria = this.filterBox.nativeElement.value;
  }

  onBlur() {
    this.refreshCriteria();
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault(); // Evita el pegado directo

    const pastedText = event.clipboardData?.getData('text') || '';
    let cleanText = pastedText
      .split(/\r?\n/)                       // separa por líneas
      .map(s => s.replace(/"/g, ''))        // elimina comillas dobles
      .map(s => s.trim())                   // quita tabs y espacios delante/detrás
      .filter(Boolean)                      // elimina líneas vacías
      .join('|');                           // únelas con |

    // Inserta en la posición del cursor
    const target = event.target as HTMLTextAreaElement;
    const start = target.selectionStart;
    const end = target.selectionEnd;

    if (cleanText.lastIndexOf('|') === cleanText.length - 1) {
      cleanText = cleanText.substring(0, cleanText.length - 1);
    }

    this.filterBox.nativeElement.value =
      this.filterBox.nativeElement.value.substring(0, start) +
      cleanText +
      this.filterBox.nativeElement.value.substring(end);

    if (cleanText.indexOf('|') != -1) {
      this.operatorInput.nativeElement.value = OperatorEnum.OperatorIn;
    }

    setTimeout(() => {
      target.selectionStart = target.selectionEnd = start + cleanText.length;
    });
  }


  filter(event: any) {
    if ((this.injector.get(Art57Section).meddra == this.injector.get(Art57Section).getSelectedSection())
      && (event.key === 'Enter')) {
      this.refresh(MeddraService);
    } else if ((this.injector.get(Art57Section).medicinalProduct == this.injector.get(Art57Section).getSelectedSection())
      && (event.key === 'Enter')) {
      this.refresh(MedicinalproductsService);
    }
  }

  setItemHistory(item: string) {
    this.operatorInput.nativeElement.value = OperatorUtil.getOperator(item);
    this.filterBox.nativeElement.value = OperatorUtil.getText(item);
  }

  addedToHistory() {
    let localStorageKey, data, arrayHistoryByTerm: any[], valueItem, historyValue;
    localStorageKey = `${this.injector.get(AuthService).getUser()}_${this.injector.get(AuthService).getOrganisation()}_${this.selectedNode.entityName}`;
    data = Object.keys(LocalStorageUtil.getLocalStorageJson(localStorageKey)).length !== 0 ? LocalStorageUtil.getLocalStorageJson(localStorageKey) : [];
    arrayHistoryByTerm = data;
    valueItem = this.filterBox.nativeElement.value;
    historyValue = `${this.operatorInput.nativeElement.value}:${valueItem}`;

    if (String(valueItem).trim().length > 0) {
      if (!arrayHistoryByTerm.includes(historyValue)) {
        arrayHistoryByTerm.push(historyValue);
        if (arrayHistoryByTerm.length > LIMIT_FOR_HISTORIES) {
          arrayHistoryByTerm.shift();
        }
      } else {
        arrayHistoryByTerm = arrayHistoryByTerm.filter((history: any) => history !== historyValue);
        arrayHistoryByTerm.push(historyValue);
      }
    }

    data = arrayHistoryByTerm;
    this.selectedNode.historyItems = arrayHistoryByTerm;
    LocalStorageUtil.setLocalStorageJson(localStorageKey, data);
  }

  includeAndOrderHistories() {
    let result = [];
    if (this.selectedNode && Object.values(this.selectedNode.historyItems).length > 0) {
      let historyItems = this.selectedNode.historyItems
      result = historyItems.slice().sort((a: any, b: any) => historyItems.indexOf(b) - historyItems.indexOf(a));
    }
    return result;
  }

  includeLabel(item: string): string {
    return `${OPERATOR_LABEL_DICCIONARY[OperatorUtil.getOperator(item)]}: ${OperatorUtil.getText(item)}`;
  }

  refresh(service: any): void {
    let criteriaColumns: string[] = this.selectedNode.getCriteriaFields();
    let entity: string = this.selectedNode.entityName;
    let criteria: string = '';

    if (this.filterBox.nativeElement.value) {
      criteriaColumns.forEach(c => criteria = criteria + c + ":" + this.operatorInput.nativeElement.value + ":" + this.filterBox.nativeElement.value + "~")
    }

    this.refreshCriteria();

    this.injector.get(service).filter(this.selectedNode, entity, criteria, 0, true)
      .subscribe({
        next: (data: any) => {
          //Update the last query if there are results
          data.node.showResults = true;
          if (data.result.length > 0) {
            // add checked field to data (by default false value)
            const itemsWithChecked = data.result.map((info: any) => ({ checked: false, ...info }));
            data.node.data.model = itemsWithChecked;
          } else {
            data.node.data.model = [];
            this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn',id:testingEnum.noResultsFoundToastMsg, detail: 'No result(s) found for the specified condition(s)', life: environment.warningElapsedTime });
          }
        },
        error: (error: any) => {
          this.injector.get(MedicinalproductsService).loading.next(false);
          this.injector.get(WebtraderService).loading.next(false);
          this.injector.get(MeddraService).loading.next(false);
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
          throw error;
        }
      });

  }

  showHistoryItem(): boolean {
    return !this.selectedNode.historyItems || Object.values(this.selectedNode.historyItems).length === 0
  }

  isSearchBarAvailable(): boolean {
    return !(this.selectedNode.parent instanceof OnDemandAutoUploadNode);
  }

}
